module.exports = "/static/assets/051cc58724149226b23311d799c1c144.png";